import { Injectable } from "@angular/core"
import { HttpErrorResponse } from "@angular/common/http"
import { NotificationsService } from "angular2-notifications"
import Utils from "../utils/utils"

@Injectable({
    providedIn: "root",
})
export class CustomNotificationsService {
    constructor(private notificationService: NotificationsService) {}

    /**
     * Extracts a human-readable error message from a server error response.
     * Tries to handle string, array, and object-shaped error payloads and
     * falls back to the provided default message when no message is found.
     *
     * @param errorResponse The raw error payload returned by the server. May be a string,
     *                      an array of strings, or an object whose values contain messages.
     * @param defaultErrorMessage The fallback message to use if no suitable error message can be extracted.
     * @returns The extracted error message or the default message if none could be found.
     */
    private extractErrorMessage(errorResponse: any, defaultErrorMessage: string): string {
        if (typeof errorResponse === "string" && errorResponse.trim()) {
            return errorResponse
        }
        if (
            Array.isArray(errorResponse) &&
            errorResponse.length > 0 &&
            errorResponse.every((item) => typeof item === "string" && item.trim())
        ) {
            return errorResponse.join("\n")
        }
        if (errorResponse && typeof errorResponse === "object") {
            for (const value of Object.values(errorResponse)) {
                if (typeof value === "string" && value.trim()) {
                    return value
                }
                if (
                    Array.isArray(value) &&
                    value.length > 0 &&
                    value.every((item) => typeof item === "string" && item.trim())
                ) {
                    return value.join("\n")
                }
            }
        }
        return defaultErrorMessage
    }

    public handleServerError(
        errorResponse: HttpErrorResponse,
        errorTitle: string,
        defaultErrorMessage: string
    ): void {
        const errorMessage = this.extractErrorMessage(errorResponse.error, defaultErrorMessage)
        this.notificationService.error(errorTitle, errorMessage, Utils.alertConfiguration)
    }
}
